function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  background: #fff;\n  padding: 24px;\n  /* box-shadow: @shadow-1; */\n  min-height: calc(100vh - 230px);\n  position: relative;\n  @media (max-width: 767px) {\n    padding: 12px;\n    min-height: calc(100vh - 160px);\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { view as Loader } from '../../atoms/loader';
var ContentInner = styled.div(_templateObject());
export default class Page extends Component {
  render() {
    var {
      children,
      loading = false,
      inner = false
    } = this.props;
    var loadingStyle = {
      height: 'calc(100vh - 184px)',
      overflow: 'hidden'
    };
    return /*#__PURE__*/React.createElement(ContentInner, null, loading ? /*#__PURE__*/React.createElement(Loader, {
      spinning: true
    }) : '', children);
  }

}
Page.propTypes = {
  children: PropTypes.node,
  loading: PropTypes.bool,
  inner: PropTypes.bool
};